<div class="container-fluid py-4">
  <mat-drawer-container class="scores-drawer-container" autosize>
    <mat-drawer-content>
      <div class="row">
        <div class="col-1 d-sm-block"></div>
        <div class="col-10 col-sm-12">
          <div class="card">

            <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
              <h4 class="mb-0">User Management</h4>
              <button mat-raised-button (click)="openInviteModal()" class="btn-invite">
                <mat-icon>person_add</mat-icon>
                Invite User
              </button>
            </div>

            <div *ngIf="loadingUsers" class="text-center py-4">
              <mat-spinner diameter="40" class="mx-auto"></mat-spinner>
              <p class="mt-2 text-muted">Loading users...</p>
            </div>

            <div class="card-body p-0" *ngIf="!loadingUsers">
              <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" class="w-100">
                  <ng-container matColumnDef="userId">
                    <th mat-header-cell *matHeaderCellDef class="fw-bold">User ID</th>
                    <td mat-cell *matCellDef="let user" class="text-muted small">{{user.userId}}</td>
                  </ng-container>

                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="fw-bold">Name</th>
                    <td mat-cell *matCellDef="let user">{{user.firstName}} {{user.lastName}}</td>
                  </ng-container>

                  <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef class="fw-bold">Email</th>
                    <td mat-cell *matCellDef="let user">{{user.email}}</td>
                  </ng-container>

                  <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef class="fw-bold">Role</th>
                    <td mat-cell *matCellDef="let user">
                      <span class="badge bg-secondary text-capitalize">{{user.role}}</span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="fw-bold">Status</th>
                    <td mat-cell *matCellDef="let user">
                      <span class="badge" [ngClass]="{
                        'bg-success':  user.status === 'CONFIRMED',
                        'bg-warning':  user.status === 'INVITED' || user.status === 'FORCE_CHANGE_PASSWORD',
                        'bg-secondary': user.status === 'UNCONFIRMED'
                      }">
                        {{user.status}}
                      </span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="scores">
                    <th mat-header-cell *matHeaderCellDef class="fw-bold">Actions</th>
                    <td mat-cell *matCellDef="let user">
                      <button *ngIf="user.role === 'recruiter'; else scoreAction"
                              mat-stroked-button color="primary"
                              (click)="viewOrganization(user)"
                              class="btn-sm">
                        <mat-icon>business</mat-icon>
                        View Organization
                      </button>
                      <ng-template #scoreAction>
                        <button mat-stroked-button color="primary"
                              (click)="getScores(user)"
                              [disabled]="loadingScores[user.userId]"
                              class="btn-sm">
                          <mat-spinner *ngIf="loadingScores[user.userId]" diameter="16" class="d-inline-block me-1"></mat-spinner>
                          <mat-icon *ngIf="!loadingScores[user.userId]">bar_chart</mat-icon>
                          Get Scores
                        </button>
                      </ng-template>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="delete">
                    <th mat-header-cell *matHeaderCellDef class="fw-bold">Delete</th>
                    <td mat-cell *matCellDef="let user">
                      <button mat-icon-button color="warn" (click)="deleteUser(user)" matTooltip="Delete user">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>

                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell text-center py-4 text-muted" [attr.colspan]="displayedColumns.length">
                      No users found.
                    </td>
                  </tr>
                </table>
              </div>
              <div class="user-pagination" *ngIf="dataSource.length || userPageNumber > 1">
                <span>Page {{ userPageNumber }} · Up to {{ userPageSize }} users</span>
                <div>
                  <button mat-stroked-button type="button" (click)="previousUserPage()" [disabled]="userPageNumber <= 1 || loadingUsers">
                    <mat-icon>chevron_left</mat-icon>
                    Previous
                  </button>
                  <button mat-stroked-button color="primary" type="button" (click)="nextUserPage()" [disabled]="!nextUserCursor || loadingUsers">
                    Next
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="col-1 d-sm-block"></div>
      </div>
    </mat-drawer-content>

    <mat-drawer mode="over" position="end" [opened]="scoreDrawerOpen" class="scores-drawer">
      <div *ngIf="selectedUser?.role === 'recruiter'; else scoreDrawer" class="organization-drawer">
        <div class="organization-drawer-header">
          <div>
            <h3>Recruiter Organization</h3>
            <p>{{ selectedUser?.firstName }} {{ selectedUser?.lastName }}</p>
          </div>
          <button mat-icon-button (click)="closeScoreDrawer()" aria-label="Close organization drawer">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div *ngIf="loadingOrganization" class="organization-drawer-state">
          <mat-spinner diameter="36"></mat-spinner>
          <p>Loading organization...</p>
        </div>

        <div *ngIf="!loadingOrganization && organizationError" class="alert alert-danger">
          {{ organizationError }}
        </div>

        <div *ngIf="!loadingOrganization && selectedOrganization as organization" class="organization-card">
          <mat-icon class="organization-icon">business</mat-icon>
          <div class="organization-details">
            <span>Organization</span>
            <h4>{{ organization.name }}</h4>
            <code>{{ organization.orgId }}</code>
          </div>
        </div>

        <div *ngIf="selectedOrganization" class="organization-actions">
          <button mat-raised-button color="primary" (click)="openRecruitmentWorkspace('dashboard')">
            <mat-icon>space_dashboard</mat-icon>
            View Recruitment Dashboard
          </button>
          <button mat-stroked-button color="primary" (click)="openRecruitmentWorkspace('benchmarks')">
            <mat-icon>work_outline</mat-icon>
            Manage Private Benchmarks
          </button>
        </div>
      </div>

      <ng-template #scoreDrawer>
        <app-user-score-drawer
        [user]="selectedUser"
        [sessions]="selectedUserSessions"
        [loading]="!!selectedUser && loadingScores[selectedUser.userId]"
        [errorMessage]="selectedUserScoreError"
        [savingStateSessionId]="savingStateSessionId"
        [savingAssessmentSessionId]="savingAssessmentSessionId"
        [savingAttemptAccess]="savingAttemptAccess"
        (closeDrawer)="closeScoreDrawer()"
        (loadDashboard)="openDashboard($event)"
        (saveState)="saveAssessmentState($event)"
        (saveAssessment)="saveAssessmentObject($event)"
        (saveAttemptAccess)="saveAssessmentAttemptAccess($event)">
        </app-user-score-drawer>
      </ng-template>
    </mat-drawer>
  </mat-drawer-container>
</div>
